<template>
  <div class="node-type-product product-pane row row-reverse">
    <div class="col-12 col-sm-8">
      <div class="row row-reverse product-content-row">
        <div class="col-12 col-sm-7">
          <div class="product-header text-center">
            <div class="product-slogan">{{product.slogan}}</div>
            <h1 class="product-name">{{product.product.title}}</h1>
            <div class="product-rating" v-if="product.rating"><span class="product-score">{{product.rating}}</span>/5</div>

            <!-- Should be replaced by node-link code below-->
            <a v-if="reviewArticleNode" :href="reviewArticleNode.relative_url" class="product-review-btn hidden-xs-down">read our review</a>
            <!--
            * Replace with below code once node to node route is working *
            <node-link class="product-review-btn hidden-xs-down"
              v-if="reviewArticleNode"
              :url="reviewArticleNode.relative_url"
              :type="reviewArticleNode.type"
              :nid="reviewArticleNode.nid"
              :title="reviewArticleNode.title">read our review</node-link>
            -->

            <!-- <div class="divider"></div> -->
          </div>
        </div>
        <div class="col-12 col-sm-5 text-center image-holder-wrapper">
          <div v-image-orientation="'wrapper'" class="image-holder">
            <img  class="product-image" v-lazy="image" :alt="product.product.title">
          </div>

          <!-- Should be replaced by node-link code below-->
          <a v-if="reviewArticleNode" :href="reviewArticleNode.relative_url" class="product-review-btn hidden-sm-up">read our review</a>
          <!--
          * Replace with below code once node to node route is working *
          <node-link class="product-review-btn hidden-sm-up"
            v-if="reviewArticleNode"
            :url="reviewArticleNode.relative_url"
            :type="reviewArticleNode.type"
            :nid="reviewArticleNode.nid"
            :title="reviewArticleNode.title">read our review</node-link>
          -->

        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="product-description" v-html="product.body"></div>
        </div>
      </div>
    </div>
    <div class="col-sm-4 col-12">
      <specification-pane v-if="properties" :properties="properties"></specification-pane>
    </div>
  </div>
</template>

<script>
  import get from 'lodash/get'

  import NodeLink from 'components/node/Link'
  import SpecificationPane from 'components/article/Specification.vue'
  import ImageOrientation from 'directives/imageOrientation'

  export default {
    name: 'product-pane',
    props: ['product'],
    mixins: [],
    components: {
      SpecificationPane,
      NodeLink,
    },
    directives: {
      ImageOrientation,
    },
    computed: {
      properties() {
        return get(this, 'product.product.properties', {})
      },
      image() {
        const originalProductImage = get(this, 'product.product.images[0].style_650w', '')
        const comparisonProductImage = get(this, 'product.images[0].style_650w', '')
        return comparisonProductImage !== '' ? comparisonProductImage : originalProductImage
      },
      reviewArticleNode() {
        return get(this, 'product.review_article.id', false) ? this.$store.getters.node(this.product.review_article.id) : false
      },
    },
    methods: {
      get,
    },
  }
</script>

<style lang="scss">
  .product-pane {
    .specification{
      @include respond-to('desktop') {
        max-width: rem-calc(240);
      }
      @include respond-to('mobile') {
        padding: rem-calc(0 20);
      }
    }
    .product-description {
      @include respond-to('mobile') {
        margin-bottom: rem-calc(28);
      }
      & > *:last-child {
        margin-bottom: 0;
      }
    }
  }
</style>

<style scoped lang="scss">

  // .divider {
  //   background: linear-gradient(to right, $rose, $spiro-disco-ball);
  //   position: relative;
  //   width: 100%;
  //   left: 0;
  //   display: block;
  //   height: rem-calc(3);
  //   margin-bottom: rem-calc(24);
  // }
  .product-content-row {
    @include respond-to('desktop') {
      margin-bottom: rem-calc(40);
    }
    @include respond-to('mobile') {
      margin-bottom: rem-calc(28);
    }
  }
  .product-pane {
    @include respond-to('desktop') {
      padding-top: rem-calc(28)
    }

  }
  .product-slogan {
    font-family: $barlow;
    font-size: rem-calc(16);
    line-height: rem-calc(19);
    font-weight: bold;
    color: $rose;
    text-transform: uppercase;
    margin-bottom: rem-calc(8);
    @include respond-to('desktop') {
      font-size: rem-calc(20);
      line-height: rem-calc(26);
      margin-bottom: rem-calc(6);
    }
  }
  .product-title {
    font-size: rem-calc(28);
    line-height: rem-calc(33);
    color: $oxford-blue;
    margin-bottom: rem-calc(4);
  }
  .product-header {
    @include respond-to('desktop') {
      max-width: rem-calc(270);
    }
    @include respond-to('mobile') {
      text-align: center;
    }
  }
  .product-rating {
    margin-top: rem-calc(-18);
    margin-bottom: rem-calc(37);
  }
  .product-review-btn {
    margin-top: rem-calc(28);
    font-size: rem-calc(14);
    line-height: rem-calc(24);
    font-weight: bold;
    text-transform: uppercase;
    padding: rem-calc(0 38);
    background-color: $rose;
    color: $white;
    display: inline-block;
  }
  .product-image {
    width: auto;
  }
  .product-description {
    font-size: rem-calc(18);
    line-height: rem-calc(26);
  }
  .image-holder-wrapper{
    @include respond-to('desktop') {
      display: flex;
      align-items: center;
    }
    .image-holder {

      .product-image{
        max-width: 85%;
        max-height: rem-calc(400);
      }

      @include respond-to('desktop') {
        text-align: left;
        &.square{
          height:100%;
          width: 100%;
          img{
            width: 100%;
          }
        }
      }
      @include respond-to('mobile') {
        text-align: center;
        &.landscape, &.square{
          display: flex;
          justify-content: center;
          align-items: center;
          img{
              padding-left: rem-calc($mobile-article-gutter);
              padding-right: rem-calc($mobile-article-gutter);
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ProductPane.vue?4d2f08d0